<template>
	<div class="bb-panel-wrapper">
		<section class="b360-section-container">
			<span class="b360-form-label" role="heading">Branding Options</span>
			<p>
				Manage your branding in the
				<router-link to="/preference-center/user-profile"
					>Preference Center</router-link
				>.
			</p>

			<template v-if="checkIfFlyer(selectedMediaType) && blinkQRCode">
				<div
					class="image-options"
					v-if="MEDIA_TYPE_OPTIONS[selectedMediaType].image"
				>
					<h2 class="branding-options-subheading">Images</h2>
					<p class="branding-options-instructions">Select up to two options:</p>
					<template v-for="item in brandingOptions">
						<div
							v-if="
								MEDIA_TYPE_OPTIONS[selectedMediaType].image.includes(item.index)
							"
							class="branding-options-wrapper"
							:class="{ disabled: setDisabled(item) }"
							:key="item.index"
							:style="[item.disabled && { cursor: 'not-allowed' }]"
							@click="!item.disabled && imageBrandingOptionsToggle(item)"
						>
							<div class="branding-options">
								<span
									v-if="allowShowToggle(item.option)"
									class="b360-item-name"
									:style="[item.disabled && { color: '#BBBBBB' }]"
									>{{ item.option }}</span
								>
								<ToggleSwitch
									v-if="allowShowToggle(item.option)"
									:id="`toggle-options-${item.index}`"
									:value="item.selected"
									:disabled="item.disabled"
								></ToggleSwitch>
							</div>
						</div>
					</template>
				</div>
				<h2 class="branding-options-subheading">Contact Information</h2>
				<template v-for="item in brandingOptions">
					<div
						v-if="
							MEDIA_TYPE_OPTIONS[selectedMediaType].nonImage.includes(
								item.index,
							)
						"
						class="branding-options-wrapper"
						:class="{ disabled: item.disabled }"
						:key="item.index"
						:style="[item.disabled && { cursor: 'not-allowed' }]"
						@click="!item.disabled && brandingOptionsToggle(item)"
					>
						<div class="branding-options">
							<span
								v-if="allowShowToggle(item.option)"
								class="b360-item-name"
								:style="[item.disabled && { color: '#BBBBBB' }]"
								>{{ item.option }}</span
							>
							<ToggleSwitch
								v-if="allowShowToggle(item.option)"
								:id="`toggle-options-${item.index}`"
								:value="item.selected"
								:disabled="item.disabled"
							></ToggleSwitch>
						</div>
					</div>
				</template>
			</template>

			<template v-else>
				<template v-for="item in brandingOptions">
					<div
						v-if="
							MEDIA_TYPE_OPTIONS[selectedMediaType].general.includes(item.index)
						"
						class="branding-options-wrapper"
						:class="{ disabled: setDisabled(item) }"
						:key="item.index"
						:style="[
							setDisabled(item) && {
								cursor: 'not-allowed',
							},
						]"
						@click="!setDisabled(item) && brandingOptionsToggle(item)"
					>
						<div class="branding-options">
							<span
								v-if="allowShowToggle(item.option)"
								class="b360-item-name"
								:style="[
									setDisabled(item) && {
										color: '#BBBBBB',
									},
								]"
								>{{ item.option }}</span
							>
							<ToggleSwitch
								v-if="allowShowToggle(item.option)"
								:id="`toggle-options-${item.index}`"
								:value="blinkDisableValue(item)"
								:disabled="setDisabled(item)"
							></ToggleSwitch>
						</div>
					</div>
				</template>
			</template>
		</section>
		<button class="b360-btn b360-btn--workspace-primary" @click="nextStep()">
			Next Step
		</button>
		<BaseModal
			v-if="showImageOptionMessageModal"
			modalTitle="Branding Options"
			:showClose="true"
			@close="showImageOptionMessageModal = false"
			class="image-options-message-modal"
		>
			<div class="modal-body" slot="modalBody">
				This flyer can include a maximum of two images. You must deselect an
				image option to make this selection.
			</div>
			<div slot="modalFooterButtons">
				<BaseButton
					color="blue"
					class="action-button"
					@onClick="showImageOptionMessageModal = false"
					>OK
				</BaseButton>
			</div>
		</BaseModal>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BaseButton from '@/components/global/BaseButton.vue';
import BaseModal from '@/components/global/BaseModal.vue';
import ToggleSwitch from '@/components/global/ToggleSwitch.vue';
import { MEDIA_ID, MEDIA_TYPE_OPTIONS } from '../../../constants/brand-builder';

export default {
	name: 'BbBranding',
	components: {
		BaseButton,
		BaseModal,
		ToggleSwitch,
	},
	data() {
		return {
			brandingPartners: [],
			partnerImage: null,
			partnerName: null,
			partnerTitle: null,
			showImageOptionMessageModal: false,
		};
	},
	computed: {
		...mapState({
			blinkQRCode: (state) => {
				if (
					state.profile.blinkQRCode &&
					state.profile.blinkQRCode.imageUri !== ''
				) {
					return state.profile.blinkQRCode.imageUri;
				}
				return '';
			},
			brandingOptions: (state) => state.workspaceBranding.brandingOptions,
			selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
			hasBlink: (state) => state.profile.blinkRegistrationInd,
		}),
	},
	methods: {
		...mapActions(['brandingOptionsToggle', 'completeVideoAction']),

		allowShowToggle(val) {
			const invalidMediaTypes = [1, 4];
			return !(
				invalidMediaTypes.includes(this.selectedMediaType) &&
				val.includes('BLINK')
			);
		},
		blinkDisableValue(item) {
			if (item.index === 11 && !this.hasBlink) return false;
			else return item.selected;
		},
		setDisabled(item) {
			if (item.index === 11 && !this.hasBlink) {
				return true;
			} else return item.disabled;
		},

		checkIfFlyer(selectedMediaType) {
			if (
				selectedMediaType === MEDIA_ID.PRICING_FLYER ||
				selectedMediaType === MEDIA_ID.FLYER
			) {
				return true;
			} else return false;
		},

		toggleBrandingSwitch(toggleIndex, event) {
			if (!event.target.closest(`#${toggleIndex}`)) {
				document.getElementById(toggleIndex).click();
			}
		},

		togglePartnerSwitch(toggleIndex, event) {
			if (!event.target.closest(`#${toggleIndex}`)) {
				document.getElementById(toggleIndex).click();
			}
		},

		imageBrandingOptionsToggle(item) {
			// We are toggling item.selected so newSelected is the opposite of its current value
			const newSelected = !item.selected;
			const otherImageOptions = MEDIA_TYPE_OPTIONS[
				this.selectedMediaType
			].image.filter((option) => option !== item.index);
			const totalOtherImageOptionsSelected = otherImageOptions.reduce(
				(total, option) => {
					let newTotal = total;
					if (this.brandingOptions[option].selected) {
						newTotal += 1;
					}
					return newTotal;
				},
				0,
			);

			if (newSelected && totalOtherImageOptionsSelected === 2) {
				this.showImageOptionMessageModal = true;
			} else {
				this.brandingOptionsToggle(item);
			}
		},
		nextStep() {
			if (
				this.selectedMediaType === MEDIA_ID.FLYER ||
				this.selectedMediaType === MEDIA_ID.EMAIL ||
				this.selectedMediaType === MEDIA_ID.VIDEO ||
				this.selectedMediaType === MEDIA_ID.PRICING_FLYER
			) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/legal`,
				});
			}
		},
	},
	created() {
		/* Add non-reactive constants */
		this.MEDIA_ID = MEDIA_ID;
		this.MEDIA_TYPE_OPTIONS = MEDIA_TYPE_OPTIONS;
	},
	mounted() {
		this.completeVideoAction(null);
	},
};
</script>

<style lang="scss" scoped>
.image-options {
	@include rem(padding-bottom, 15px);
	@include rem(margin-bottom, 30px);
	border-bottom: 1px solid $b360-color--gray__light;
}

.branding-options-subheading {
	font-size: 1rem;
}

p.branding-options-instructions {
	@include rem(padding-bottom, 5px);
	font-size: 1rem;
	color: $b360-color--gray__darkest;
	font-style: italic;
}

.branding-options-wrapper {
	cursor: pointer;
}

.branding-options {
	display: flex;
	justify-content: space-between;
	@include rem(margin-bottom, 15px);
	pointer-events: none;
}

.branding-partner {
	display: grid;
	grid-template-columns: 45px 1fr 40px;
	grid-gap: 5px;
	align-items: center;
	@include rem(margin-bottom, 15px);

	img {
		border-radius: $b360-border-radius-medium;
	}

	&--information {
		display: flex;
		flex-direction: column;
		@include rem(margin-left, 15px);
	}

	&--title {
		@include typo--roboto__light;
		@include rem(font-size, 15px);
	}
}

.image-options-message-modal {
	/deep/ .modal-wrapper {
		margin-top: 120px;
	}

	.modal-body {
		@include rem(padding, 22px 15px);
	}

	.action-button {
		display: block;
		margin-left: auto;
		@include rem(width, 90px);

		@include phablet {
			width: 100%;
		}
	}
}
</style>
